<template>
  <el-form ref="queryForm"
           class="kye-query-form"
           v-next
           inline
           :model="model">
    <template v-for="item in rowFields">
      <form-item-menu v-if="(item.type === 'menu' || item.type === 'rangeMenu') && !item.formatterLabel"
                      :ref="'menuItem' + item.propertyName"
                      :index="value[item.propertyName + 'Index']"
                      :key="item.propertyName"
                      :fields="rowFields"
                      :model="model"
                      :option="item"
                      :XPathHash="XPathHash"
                      @open-dept-tree="openDeptTree"
                      @menu-change="menuChange">
      </form-item-menu>
      <form-item v-else
                 :key="item.propertyName"
                 :fields="rowFields"
                 :model="model"
                 :item="item"
                 :XPathHash="XPathHash"
                 @open-dept-tree="openDeptTree" />
    </template>
    <el-form-item v-if="generic && generic.searchCode"
                  class="item-generic"
                  title="可以选择“通用查询”里面的模板进行组合查询"
                  label="查询模板">
      <kye-select v-model="templateId" placeholder="" style="width:78px;">
        <kye-option
          v-for="opt in templateList"
          :key="opt.id+opt.name"
          :label="opt.name"
          :value="opt.id">
        </kye-option>
      </kye-select>
    </el-form-item>
    <slot name="before"></slot>
    <kye-button class="kye-query-form_searchBtn"
                type="primary"
                icon="layout layout-search1"
                :auth="option.auth"
                :loading="option.isLoading"
                hotkey="ctrl+q"
                @click="onSubmit">查询(Q)
    </kye-button>
    <span v-if="showOverflowControl" class="kye-query-form_more" @click="handleFormMode">
      {{ isOverflow ? '收起' : '展开' }}
      <i class="layout" :class="[isOverflow ? 'layout-arrow-up' : 'layout-arrow-down']"></i>
    </span>
    <slot name="after"></slot>
    <!-- tools内联到右边 -->
    <tool-list v-if="option.inlineTools && tools"
               :active="false"
               :tools="tools"
               style="display:inline-block;position:absolute;right:0;">
    </tool-list>
    <dept-dialog ref="deptDialog" :model="model" :axios="axios" @change="deptChange" :preloadDeptTree="false"></dept-dialog>
    <dept-multiple-dialog ref="deptMultipleDialog" :model="model" @change="deptChange" :preloadDeptTree="false"></dept-multiple-dialog>
  </el-form>
</template>

<script>
  import { throttle } from 'lodash'
  import Schema from 'async-validator'
  import mixins from '../../mixins'
  import { createModel, getXPath } from 'public/utils'
  import deptApi from 'public/utils/dept-api'
  import { perfectField, mapFormModelParams, mapGenericSearchParams, appendGenericVosByTemplate } from './utils'
  import FormItem from './form-item.vue'
  import DeptDialog from './dept-dialog.vue'
  import DeptMultipleDialog from './dept-multiple-dialog'
  import hash from 'hash-sum'


  export default {
    mixins: [mixins],
    name: 'query-form',
    components: { FormItem, DeptDialog, DeptMultipleDialog },
    props: {
      value: {
        type: Object,
        default: () => ({})
      },
      option: {
        type: Object,
        default: () => ({})
      },
      fields: {
        type: Array,
        default: () => ([])
      },
      tools: Array,
      generic: Object,
      genericModel: Object,
      templateList: Array,
    },
    data () {
      return {
        model: {},
        menuWidth: 160,
        rowFields: [],
        templateId: '',
        XPathHash: '',
        axios: {},
        isOverflow: this.option.overflow === true && !this.option.defaultCollapse
      }
    },
    created () {
      this.initFields()
      this.handleRowFields()
      this.model = this.createModel()
      let params = {
        ...mapFormModelParams(this.fields, this.model),
        ...mapGenericSearchParams(this.fields, this.model)
      }
      this.$emit('created', this.model, params)
    },
    mounted () {
      // 在非弹窗或者主动resize时重新计算当前query-form展示的项
      if (!this.option.dialog || this.option.resize) {
        this.resizeEvent = throttle(this.handleResize, 16)
        window.addEventListener('resize', this.resizeEvent)
        this.$bus.$on('SWITCH_MENU', this.handleSwitchMenu)
      }
      this.getQueryFormXpath()
    },
    beforeDestroy () {
      if (!this.option.dialog) {
        window.removeEventListener('resize', this.resizeEvent)
        this.$bus.$off('SWITCH_MENU', this.handleSwitchMenu)
      }
    },
    computed: {
      rules () {
        return this.rowFields.reduce((s, v) => {
          if (v.attr && v.attr.rules) {
            s[v.propertyName] = v.attr.rules
          }
          return s
        }, {})
      },
      showOverflowControl () {
        const { overflow, showOverflowControl } = this.option
        const formContainerWidth = this.getTotalWidth()
        const visibleFields = this.fields.filter(i => i.show)
        const fieldsWidth = visibleFields.reduce((sum, v) => (sum += this.getFieldWidth(v)), 0)
        return showOverflowControl && overflow && fieldsWidth > formContainerWidth
      }
    },
    watch: {
      fields (val) {
        this.handleRowFields(val)
      }
    },
    methods: {
      handleFormMode () {
        this.isOverflow = !this.isOverflow
        this.handleRowFields()
        this.$emit('queryFormCollapse', this.isOverflow)
      },
      getQueryFormXpath () {
        const Xpath = getXPath(this.$el)
        this.XPathHash = hash(Xpath)
      },
      setAxios (val) {
        this.axios = val
      },
      getModel () {
        return this.model
      },
      setModel (data) {
        // 设置单选组织树
        const setDeptData = (item, data) => {
          item._queryValue = data[item.propertyName]
          item.queryValue2 = data[item.propertyName][0].value
          this.$set(this.model, item.propertyName, data[item.propertyName][0].value)
        }
        this.rowFields.forEach(item => {
          if (item.type === 'menu') {
            item.options.forEach(item2 => {
              if (item2.propertyName in data) {
                if (item2.type === 'dept') {
                  setDeptData(item2, data)
                } else {
                  this.$set(this.model, item2.propertyName, data[item2.propertyName])
                }
              }
            })
          } else if (item.propertyName in data) {
            if (item.type === 'dept') {
              setDeptData(item, data)
            } else {
              this.$set(this.model, item.propertyName, data[item.propertyName])
            }
          }
        })
      },
      onSubmit () {
        const validator = new Schema(this.rules)
        validator.validate(this.model, (errors, fields) => {
          if (errors) {
            this.$message.warning(errors[0].message)
          } else {
            let params = {
              ...mapFormModelParams(this.rowFields, this.model),
              ...mapGenericSearchParams(this.rowFields, this.model)
            }
            // 拼接查询模板
            let model = this.genericModel
            if (model && this.templateList && this.templateId) {
              let obj = this.templateList.find(v => v.id === this.templateId)
              if (obj && obj.columnList) {
                let vos = appendGenericVosByTemplate(obj.columnList, model.fields, model.esFlag)
                params.generic.vos.push(...vos)
              }
            }
            this.queryLog_zh_cn = this.getQueryLog_zh_cn()
            this.$emit('submit', this.model, params, this.queryLog_zh_cn)
          }
        })
      },
      onReset () {
        this.model = this.createModel()
        this.resetFields()
        this.$emit('reset', this.model)
      },
      resetFields () {
        this.$refs.queryForm.resetFields()
        // 清除9级组织 label
        this.rowFields.forEach(v => {
          if (v.type === 'dept') {
            v._queryValue = null
            v._queryValue2 = null
          }
        })
      },
      isFormItemMenu (item) {
        return (item.type === 'menu' || item.type === 'rangeMenu') && !item.formatterLabel
      },
      createModel () {
        let model = createModel(this.fields, 'propertyName', this.getDefaultValue)
        if (this.fields && this.fields.length) {
          this.fields.forEach(v => {
            if (v.labelType === 'radio' && v.labelModel && v.labelValue) {
              model[v.labelModel] = v.labelValue
            }

            // 赋值下拉场景
            if (this.isFormItemMenu(v) && v.options && v.options.length) {
              let menuValue = this.getDefaultValue(this.value, v.propertyName)
              menuValue && this.$refs[v.propertyName] && this.$refs[v.propertyName][0].setMenuValue(menuValue)
            }

            if (v.type === 'dept') {
              this.setDeptDefaultValue(v)
            }
            if (typeof v.remoteMethod === 'function') {
              this.setRemoteDefaultValue(v, model)
            }
          })
        }
        return model
      },
      // 动态修改 item-menu 的选中值
      changeMenuItemIndex (key, index) {
        const formItemMenu = 'menuItem' + key
        const formItemMenuInstance = this.$refs[formItemMenu] && this.$refs[formItemMenu][0]
        if (formItemMenuInstance) {
          formItemMenuInstance.changeMenuItemByIndex(index)
        }
      },
      getDefaultValue (v, key) {
        if (this.value.hasOwnProperty(key)) {
          let func = this.value[key]
          if (typeof func === 'function') {
            return func()
          }
          return this.value[key]
        } else {
          return v.default || ''
        }
      },
      initFields () {
        if (this.fields && this.fields.length) {
          this.fields.forEach(this.mergeFormField)
        }
      },
      mergeFormField (v) {
        // 必传字段，个性设置里不可编辑
        v.required = !!v.required
        let show = !!v.show || v.required
        this.$set(v, 'show', show)
        this.$set(v, '$show', show)
        let span = this.option.span && +v.span // 配置span则启用自定义布局
        v.span = span || (this.option.dialog ? 4 : (v.dateType && v.dateType.includes('range') ? 6 : 3))
        if ((v.type === 'range' || v.type === 'rangeMenu') && v.options && v.options.length) {
          v.options.forEach(this.mergeField)
        } else if (v.type === 'menu' && v.options && v.options.length) {
          v.label = v.options[0].label
          v.options.forEach(k => {
            if (k.type === 'range' && k.options && k.options.length) {
              k.options.forEach(this.mergeField)
            } else {
              this.mergeField(k)
            }
          })
          // menu 类型的子项有日期区间
          let dateRange = !span && v.options.some(k => k.dateType && k.dateType.includes('range'))
          if (dateRange) {
            v.span = this.option.dialog ? 4 : 6
          }
        } else if (v.type === 'area' && v.options && v.options.length) {
          v.span = (span || (this.option.dialog ? 4 : 3)) * v.options.length
          v.label = v.options.filter(v => v.label).map(v => v.label).join('-')
        } else if (v.type === 'dept') {
          this.$set(v, '_queryValue', null)
          this.$set(v, 'queryValue2', null)
        }
        this.mergeField(v)
      },
      mergeField (v) {
        if (this.option[v.propertyName]) {
          Object.assign(v, this.option[v.propertyName])
        }
        if (!v.hasOwnProperty('default') && (v.type === 'area' || (v.type === 'select' && v.attr && v.attr.multiple))) {
          v.default = []
        }
        perfectField(this, v)
      },
      handleResize () {
        this.setPwidth()
        this.handleRowFields()
      },
      handleSwitchMenu (width) {
        this.menuWidth = width
        this.setPwidth()
        this.handleRowFields()
      },
      menuChange (item, menu) {
        if (item.width !== menu.width) {
          item.width = menu.width
          this.handleRowFields()
        }
      },
      handleRowFields (fields = this.fields) {
        // 内联表单溢出
        const isOverflow = this.showOverflowControl ? this.isOverflow : this.option.overflow
        if (isOverflow) {
          this.rowFields = fields.filter(v => v.show)
          return
        }
        this.$nextTick(_ => {
          let sum = 0
          let arr = []
          let maxWidth = this.getTotalWidth()
          if (this.showOverflowControl) {
            maxWidth -= 85
          }
          fields.forEach(v => {
            if (v.show) {
              sum += this.getFieldWidth(v)
              if (sum < maxWidth) {
                arr.push(v)
              }
            }
          })
          this.rowFields = arr
        })
      },
      getTotalWidth () {
        // 支持表单默认展示行数
        const maxRows = parseInt(this.option.maxRows || 1)
        const scrollBar = 17
        // 查询模板140，查询按钮85 + 左右内边距32 + 滚动条17 + 容错因子26(其实就是一个兜底，尽可能的不让查询掉下去) + 85 收起展开
        const diff = this.generic && this.generic.searchCode ? 140 + 160 : 160
        let maxWidth = this.getMaxWidth() - diff
        maxWidth = maxWidth * maxRows - scrollBar * (maxRows - 1)
        return maxWidth
      },
      getFieldWidth (field) {
        let type = field.type
        let w = parseInt(field.width)
        // 地址组件不计算 label
        if (type !== 'area' && field.label) {
          w += field.label.length * 12 + 12
        }
        // 三角箭头
        if (type && type.includes('menu')) {
          w += 16
        }

        return w
      },
      setPwidth () {
        let pwidth = 0
        const dom = this.$parent && this.$parent.$el
        if (dom) {
          pwidth = dom.getBoundingClientRect().width
        }
        this.pwidth = pwidth || 1280
      },
      getMaxWidth () {
        if (!this.pwidth) {
          this.setPwidth()
        }
        return (this.option.dialog || this.option.fixedHeader) ? this.pwidth : (window.innerWidth - this.menuWidth - (this.option.offsetLeft ? this.option.offsetLeft : 0))
      },
      openDeptTree (field) {
        if (field.multiple) {
          this.$refs.deptMultipleDialog.open(field)
        } else {
          this.$refs.deptDialog.open(field)
        }
      },
      deptChange (e) {
        this.$set(this.model, `_deptContainLeaf_${e.key}`, e.leaf ? 1 : 0)
        this.$set(this.model, `_deptInfo_${e.key}`, e.idsInfo)
      },
      getQueryLog_zh_cn () {
        let arr = []
        this.$el && this.$el.querySelectorAll('.el-form-item').forEach(v => {
          let value = Array.from(v.querySelectorAll('.el-input__inner'))
            .map(t => t.value && t.clientWidth ? t.value : '') // 排除隐藏的 input (clientWidth=0)
            .join(' ')
            .trim()
          let tags = v.querySelectorAll('.el-select__tags-text').length
          if (value && !tags) {
            arr.push(`(${v.innerText.replace(/\s/g, '')} ${v.getAttribute('operation')} ${value})`)
          } else if (tags) {
            // el-select multiple
            // 通过正常的文本抓取不到正确的tags，通用查询的多选下拉框单独提供labels属性
            tags = Array.from(v.querySelectorAll('.el-select')).map(t => t.getAttribute('labels')).join('')
            arr.push(`(${v.textContent.replace(/\s.*/, '')} ${v.getAttribute('operation')} ${tags})`)
          }
        })
        return arr.join(' 与 ')
      },
      setRemoteDefaultValue (v, model) {
        const propertyName = v.propertyName
        const userOptions = this.getDefaultValue(v, propertyName)
        // 判断数据结构是否满足赋值要求 [{ label, value }] 或者 { label, value }
        if (Array.isArray(userOptions)) {
          const has = userOptions.every(v => v.hasOwnProperty('label') && v.hasOwnProperty('value'))
          if (has) {
            v.options = userOptions.map(v => v)
            model[propertyName] = userOptions.map(v => v.value)
          }
        } else {
          if (Object.prototype.toString.call(userOptions) === '[object Object]') {
            const has = userOptions.hasOwnProperty('label') && userOptions.hasOwnProperty('value')
            if (has) {
              v.options = [userOptions]
              model[propertyName] = userOptions.value
            }
          }
        }
      },
      async setDeptDefaultValue() {
        // const { deptMap = {} } = this.$store.state.orgTree || {}
        const deptMaps = await deptApi.getAllOrgMap() || {}
        const _start = () => {
          try {
            if (this.fields && this.fields.length) {
              this.fields.forEach(v => {
                if (v.type === 'dept') {
                  const { propertyName, multiple } = v
                  // 初始化用户值
                  let userValues = this.getDefaultValue(this.value, v.propertyName)
                  const isInitDeptData = !v._queryValue && (userValues || (Array.isArray(userValues) && userValues.length))
                  if (isInitDeptData) {
                    // const deptMaps = this.$store.state.orgTree.deptMap || {}
                    if (typeof userValues === 'string') userValues = [userValues]

                    const _values = userValues.reduce((v, id) => {
                      const value = deptMaps[id]
                      value && v.push(value)
                      return v
                    }, [])

                    if (_values.length) {
                      const ids = _values.map(i => i.id)
                      const qv = multiple ? [{label: _values.map(i => i.name).join(','), value: ids}] : [{label: _values[0].name, value: ids}]
                      this.$set(v, '_queryValue', qv)
                      this.$set(v, 'queryValue2', ids)
                      this.$nextTick(() => {
                        this.deptChange({
                          key: propertyName,
                          leaf: true,
                          idsInfo: _values.map(i => ({
                            id: i.id,
                            name: i.name,
                            departmentIdRoute: i.departmentIdRoute,
                            departmentRoute: i.departmentRoute,
                            level: i.level
                          }))
                        })
                      })
                    }
                  }
                }
              })
            }
          } catch (e) {
            console.log('e', e)
          }
        }
        _start()
        // const unWatch = () => {
        //   if (typeof this._unWatchDeptMap === 'function') {
        //     this._unWatchDeptMap()
        //   }
        // }
        // if (Object.keys(deptMap).length) {
        //   unWatch()
        //   _start()
        // } else {
        //   unWatch()
        //   this._unWatchDeptMap = this.$watch('$store.state.orgTree.deptMap', () => {
        //     _start()
        //     unWatch()
        //   })
        // }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/public/components/query-table/query-form.vue